import { createContext, useContext, useState } from "react";

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const [menuOptions, setMenuOptions] = useState([]);
  const [isMenuLoaded, setIsMenuLoaded] = useState(false);

  const updateMenuOptions = (options) => {
    setMenuOptions(options || []);
    setIsMenuLoaded(true);
  };

  return (
    <MenuContext.Provider
      value={{
        menuOptions,
        setMenuOptions: updateMenuOptions,
        isMenuLoaded,
        setIsMenuLoaded,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);